// Ringtone for incoming calls. Plays the MP3 on a loop and falls back to a
// WebAudio double-beep when the file is missing or the browser refuses to play
// it. Browsers only allow sound after the page has had a click or key press,
// so the first user gesture "unlocks" audio for later rings.
export function createRinger(src) {
  let audio = null;
  let ctx = null;
  let beepTimer = null;
  let ringing = false;

  const getCtx = () => {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    if (!ctx) ctx = new Ctx();
    return ctx;
  };

  const unlock = () => {
    try {
      const c = getCtx();
      if (c && c.state === "suspended") c.resume();
    } catch {
      /* no WebAudio */
    }
  };
  ["click", "keydown", "touchstart"].forEach((ev) => window.addEventListener(ev, unlock, { once: true, passive: true }));

  const beepOnce = () => {
    const c = getCtx();
    if (!c) return;
    [0, 0.35].forEach((offset) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.frequency.value = 880;
      gain.gain.setValueAtTime(0.0001, c.currentTime + offset);
      gain.gain.exponentialRampToValueAtTime(0.25, c.currentTime + offset + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + offset + 0.25);
      osc.connect(gain).connect(c.destination);
      osc.start(c.currentTime + offset);
      osc.stop(c.currentTime + offset + 0.3);
    });
  };

  const startBeep = () => {
    if (beepTimer) return;
    beepOnce();
    beepTimer = setInterval(beepOnce, 1600);
  };

  return {
    start() {
      if (ringing) return;
      ringing = true;
      try {
        if (!audio) {
          audio = new Audio(src);
          audio.loop = true;
        }
        audio.currentTime = 0;
        const p = audio.play();
        if (p && p.catch) p.catch(() => ringing && startBeep());
      } catch {
        startBeep();
      }
      if (navigator.vibrate) navigator.vibrate([400, 200, 400]);
    },
    stop() {
      ringing = false;
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
      clearInterval(beepTimer);
      beepTimer = null;
      if (navigator.vibrate) navigator.vibrate(0);
    },
  };
}
